import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1102305b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "praise-modal-email-field",
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "praise-send-email",
  class: "screen-reader-only"
}, " Field for praise recipients ", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}

import InputText from 'primevue/inputtext'
import { ref, computed, onMounted } from 'vue'

type Props = {
    praiseeEmail: string | undefined
    isInvalid: boolean
    errorMsg?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PraiseModalDeliveryEmail',
  props: /*#__PURE__*/_mergeModels({
    praiseeEmail: {},
    isInvalid: { type: Boolean },
    errorMsg: {}
  }, {
    "emails": {},
    "emailsModifiers": {},
  }),
  emits: ["update:emails"],
  setup(__props: any) {

const props = __props
const emails = _useModel(__props, 'emails')

onMounted(() => {
    emails.value = props.praiseeEmail ? props.praiseeEmail + ';' : ''
})

const updateEmailInput = (emails): string => {
    if (emails?.endsWith(' ')) {
        // attempt to write another email
        const cleanEmails = emails.trim()
        if (
            cleanEmails &&
            !cleanEmails.endsWith(';') &&
            !cleanEmails.endsWith(',')
        ) {
            const delimiter = /[;,]/.exec(cleanEmails)?.[0] ?? ';' // find the first delimiter
            return cleanEmails + delimiter + ' ' // append delimiter
        }
    }
    return emails ?? ''
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createVNode(_unref(InputText), {
      id: "praise-send-email",
      modelValue: emails.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emails).value = $event)),
      class: "input-text",
      "model-value": updateEmailInput(emails.value),
      invalid: _ctx.isInvalid
    }, null, 8, ["modelValue", "model-value", "invalid"]), [
      [
        _directive_tooltip,
        
                'Additional recipients will be CC\'d. Emails must be separated with \',\' or \';\''
            ,
        void 0,
        { top: true }
      ]
    ]),
    (_ctx.isInvalid && _ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.errorMsg), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})